export const USER_PRIMARY_COLOR_REGEX = new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$");

export const LOCAL_STORAGE_PRIMARY_COLOR = "primaryColor";

export const SITE_DEFAULT_PRIMARY_COLOR = "#5f8eb1";

export const REFETCH_DATA_INTERVAL = 15 * 60 * 1000;
